import React from "react";
import "./Intro.css";
import Github from "../../img/github.png";
import Insta from "../../img/instagram.png";
import Linkedin from "../../img/linkedin.png";
import vector1 from "../../img/Vector1.png";
import vector2 from "../../img/Vector2.png";
import thumbup from "../../img/thumbup.png";
// import Rj from '../../img/rj.png'
import Crown from "../../img/crown.png";
import glassesimoji from "../../img/glassesimoji.png";
import Rj from "../../img/rjquality.png";
import Floating from "../FloatingDiv/Floating";
import { themeContext } from "../../Context";
import { useContext } from "react";
import {Link} from 'react-scroll'

// import {AnimatePresence, motion} from 'framer-motion/dist/framer-motion'
function Intro() {
  const theme=useContext(themeContext);
  const darkMode=theme.state.darkMode;
  return (
    <div className="intro">
      <div className="i-left">
        <div className="i-name">
          <span  style={{color:darkMode?'white':''}} >Hy! I Am</span>
          <span>Ranjeet Prasad</span>
          <span  style={{color:darkMode?'white':''}} >
            Aspiring Software Developer
            <br />
            Final Year Studnet at
            <br />
            Dehli Technological University
            <br />
            Pursuing Electronics and Communication Engineering
          </span>
        </div>
        <Link spy={true} to="Contact" smooth={true} activeClass="'activeClass">
        <button className="i-button button">Hire me</button>
        </Link>
        

        <div className="i-icon">
          <a href="https://github.com/ranjeet16pd">
            <img src={Github} alt="" />
          </a>

          <a href="https://www.linkedin.com/in/ranjeet-prasad-235115206/">
            <img src={Linkedin} alt="" />
          </a>

          <a href="https://www.instagram.com/ranjeet_r.j_/">
            <img src={Insta} alt="" />
          </a>
          
        </div>
      </div>

      <div className="i-right">
        <img src={vector1} alt="" />
        <img src={vector2} alt="" />
        <img src={Rj} alt="" />
        <img src={glassesimoji} alt="" />

        <div style={{ top: "-4%", left: "68%" }} className="floating-div">
          <Floating image={Crown} txt1="Web" txt2="Developer" />
        </div>
        <div style={{ top: "20rem", left: "-1rem" }} className="floating-div">
          <Floating image={thumbup} txt1="Problem " txt2="Solver" />
        </div>

        {/* blur div (html DIV) */}
        <div
          className="blur"
          style={{ backgroundColor: "rgb(238 210 255)" }}
        ></div>
        {/* blur div (html DIV) */}
        <div
          className="blur"
          style={{
            background: "#C1F5FF",
            top: "17rem",
            width: "21rem",
            height: "-9rem",
          }}
        ></div>
      </div>
    </div>
  );
}

export default Intro;
